import type { Lang } from '../types';

export interface ResetPasswordText {
  invalidLinkTitle: string;
  invalidLinkSubtitle: string;
  requestNewLink: string;
  title: string;
  subtitleDefault: string;
  subtitleDone: string;
  newPasswordLabel: string;
  newPasswordPlaceholder: string;
  confirmPasswordLabel: string;
  confirmPasswordPlaceholder: string;
  submitBtn: string;
  submittingBtn: string;
  doneBody: string;
  signIn: string;
  backToLogin: string;
  errorMismatch: string;
  errorTooShort: string;
}

export const resetPasswordText: Record<Lang, ResetPasswordText> = {
  cs: {
    invalidLinkTitle: 'Neplatný odkaz',
    invalidLinkSubtitle: 'Tomuto odkazu chybí token pro obnovení hesla.',
    requestNewLink: 'Požádat o nový odkaz',
    title: 'Nastavit nové heslo',
    subtitleDefault: 'Zvolte silné heslo pro svůj účet',
    subtitleDone: 'Heslo bylo změněno',
    newPasswordLabel: 'Nové heslo',
    newPasswordPlaceholder: 'Alespoň 8 znaků',
    confirmPasswordLabel: 'Potvrďte nové heslo',
    confirmPasswordPlaceholder: 'Zopakujte heslo',
    submitBtn: 'Nastavit nové heslo',
    submittingBtn: 'Ukládám…',
    doneBody: 'Vaše heslo bylo aktualizováno. Nyní se můžete přihlásit s novým heslem.',
    signIn: 'Přihlásit se',
    backToLogin: 'Zpět na přihlášení',
    errorMismatch: 'Hesla se neshodují',
    errorTooShort: 'Heslo musí mít alespoň 8 znaků',
  },
  en: {
    invalidLinkTitle: 'Invalid link',
    invalidLinkSubtitle: 'This reset link is missing its token.',
    requestNewLink: 'Request a new reset link',
    title: 'Set new password',
    subtitleDefault: 'Choose a strong password for your account',
    subtitleDone: 'Password changed',
    newPasswordLabel: 'New password',
    newPasswordPlaceholder: 'At least 8 characters',
    confirmPasswordLabel: 'Confirm new password',
    confirmPasswordPlaceholder: 'Repeat your password',
    submitBtn: 'Set new password',
    submittingBtn: 'Saving…',
    doneBody: 'Your password has been updated. You can now sign in with your new password.',
    signIn: 'Sign in',
    backToLogin: 'Back to sign in',
    errorMismatch: 'Passwords do not match',
    errorTooShort: 'Password must be at least 8 characters',
  },
  vi: {
    invalidLinkTitle: 'Liên kết không hợp lệ',
    invalidLinkSubtitle: 'Liên kết đặt lại này thiếu mã xác thực.',
    requestNewLink: 'Yêu cầu liên kết mới',
    title: 'Đặt mật khẩu mới',
    subtitleDefault: 'Chọn mật khẩu mạnh cho tài khoản của bạn',
    subtitleDone: 'Mật khẩu đã được thay đổi',
    newPasswordLabel: 'Mật khẩu mới',
    newPasswordPlaceholder: 'Ít nhất 8 ký tự',
    confirmPasswordLabel: 'Xác nhận mật khẩu mới',
    confirmPasswordPlaceholder: 'Nhập lại mật khẩu',
    submitBtn: 'Đặt mật khẩu mới',
    submittingBtn: 'Đang lưu…',
    doneBody: 'Mật khẩu của bạn đã được cập nhật. Bạn có thể đăng nhập bằng mật khẩu mới.',
    signIn: 'Đăng nhập',
    backToLogin: 'Quay lại đăng nhập',
    errorMismatch: 'Mật khẩu không khớp',
    errorTooShort: 'Mật khẩu phải có ít nhất 8 ký tự',
  },
  uk: {
    invalidLinkTitle: 'Недійсне посилання',
    invalidLinkSubtitle: 'Цьому посиланню бракує токена для скидання пароля.',
    requestNewLink: 'Запросити нове посилання',
    title: 'Встановити новий пароль',
    subtitleDefault: 'Оберіть надійний пароль для свого облікового запису',
    subtitleDone: 'Пароль змінено',
    newPasswordLabel: 'Новий пароль',
    newPasswordPlaceholder: 'Щонайменше 8 символів',
    confirmPasswordLabel: 'Підтвердіть новий пароль',
    confirmPasswordPlaceholder: 'Повторіть пароль',
    submitBtn: 'Встановити новий пароль',
    submittingBtn: 'Збереження…',
    doneBody: 'Ваш пароль оновлено. Тепер ви можете увійти з новим паролем.',
    signIn: 'Увійти',
    backToLogin: 'Назад до входу',
    errorMismatch: 'Паролі не збігаються',
    errorTooShort: 'Пароль має містити щонайменше 8 символів',
  },
};
